import GoogleMapReact from 'google-map-react';
import { useEffect, useState } from 'react'
import { EnvironmentFilled} from "@ant-design/icons";

export const GoogleMap = ({location}) => {

    const address=`${location?.addressLine}, ${location?.postalCode}, ${location?.locality}, ${location?.administrativeArea}`

    const [center, setCenter] = useState({ lat: 0, lng: 0 });

    useEffect(() => {
        const getCoordinates = async () => {
            try {
                const response = await fetch(
                    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                        address
                    )}&key=AIzaSyCtmjrbwFhUPNP-LfETh_aAKaFuZJhwDm4`
                );

                if (!response.ok) {
                    throw new Error('Error al obtener las coordenadas');
                }

                const data = await response.json();
                const { results } = data;

                if (results.length > 0) {
                    const { lat, lng } = results[0].geometry.location;
                    setCenter({ lat, lng });
                } else {
                    throw new Error('No se encontraron resultados para la dirección proporcionada');
                }
            } catch (error) {
                console.error(error);
            }
        };

        getCoordinates();
    }, [address]);

    const Marker = ({ text }) => <div style={{color:'red', fontSize:'25px'}}><EnvironmentFilled /></div>;


    return (
        <div className="web-map" style={{ width: '100%', height: '500px', borderRadius: '25px', overflow: 'hidden' }}>
        <div style={{ height: '100%', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyCtmjrbwFhUPNP-LfETh_aAKaFuZJhwDm4" }}
                defaultCenter={{ lat: center.lat, lng: center.lng }}
                center={{ lat: center.lat, lng: center.lng }}
                defaultZoom={15}
            >
                <Marker
                    lat={center.lat}
                    lng={center.lng}
                />
            </GoogleMapReact>
        </div>
        </div>
    );
}
